/**
 * Validates client export inputs
 * @param {Object} clientData - Client data with quarter, year, company
 * @param {Array} companyNames - List of valid company names
 * @param {Function} showAlert - Function to display alerts
 * @returns {boolean} - Whether validation passed
 */
export const validateInputsClient = (clientData, companyNames, showAlert) => {
  if (clientData.quarter === null || clientData.year === null || clientData.company === null) {
    showAlert("error", "Error in Client Inputs");
    return false;
  }
  if (!companyNames.includes(clientData.company)) {
    showAlert("error", `Input company name: ${clientData.company} is not in list`);
    return false;
  }
  return true;
};

/**
 * Validates competitor export inputs
 * @param {Object} competitorData - Competitor data with company name
 * @param {Array} companyNames - List of valid company names
 * @param {Function} showAlert - Function to display alerts
 * @returns {boolean} - Whether validation passed
 */
export const validateInputsCompetitor = (competitorData, companyNames, showAlert) => {
  if (competitorData.company === null) {
    showAlert("error", "Error in Competitor Inputs");
    return false;
  }
  if (!companyNames.includes(competitorData.company)) {
    showAlert("error", `Input company name: '${competitorData.company}' is not in list`);
    return false;
  }
  return true;
};